module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0030.jpg?v=04330af6";